import React, { Component } from 'react';
import { connect } from 'react-redux';
import FadeLoader from "react-spinners/FadeLoader";
import './Display.css';
import { Trans, withTranslation } from 'react-i18next';
import { getUrlWord } from '../../util/helpers/Helpers';
import { getAcceptedImageList, getAllRounds } from '../../actions/PhotowallActions';
import { setCustomInputStyling, randomizeArray, showEmbedFooter, isValidJSON, returnValueIfNotEmpty } from '../../util/helpers/Helpers';
import LazyLoad from 'react-lazy-load';
import StackGrid from 'react-stack-grid';
import Popup from "reactjs-popup";
import { API_V2_URL } from '../../util/Constants';
import axios from 'axios';
import $ from 'jquery';

class Display extends Component {


    constructor(props) {

        super(props);

        this.state = {
            tncs: false,
            optin: false,
            codeInjected: false,
            loader: false,
            anchor: null,
            pageSet: {
                isPrevEnabled: false,
                isNextEnabled: true
            },
            autoCarouselIntervalObject: 0,
            popupAssetUrl: null,
            open: false
        }
        this.showLoader = this.showLoader.bind(this);
        this.goToNextPage = this.goToNextPage.bind(this);
        this.goToPrevPage = this.goToPrevPage.bind(this);
        this.updateGrid = this.updateGrid.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);

        this.shapesList = {
          1: '',
          2: 'no-border-radius',
          3: 'no-border-radius dyn-skew',
          4: 'dyn-circle',
          5: 'no-border-radius dyn-shield',
        };
        this.defaultShape = 1;
        this.classRadius = '';
    }

    showLoader(app, e) {
        if (e.preventDefault) {
            e.preventDefault();
        }

        if (e) {
            window.scrollTo(0, 0);
        }

        this.setState({
            loader: e
        })
    }

    processDefaultFilters = (filterId, imageList) => {
        switch (filterId) {
            case 1:
                return imageList.sort(function (a, b) {
                    var c = new Date(a.created_date);
                    var d = new Date(b.created_date);
                    return d - c;
                });
            case 2:
                return imageList.sort(function (a, b) {
                    return b.vote_count - a.vote_count;
                });
            case 3:
                return randomizeArray(imageList);
            default:
                return imageList;
        }
    };


    getParentList = () => {
        // if (this.state.customFilterImageState > 0 && this.state.filterImageState > 0) {
        //     return this.processDefaultFilters(this.state.filterImageState, this.state.filteredImagesList);
        // }
        // if (this.state.customFilterImageState > 0) {
        //     return this.state.filteredImagesList;
        // }
        // else {
        //     const { competition: comp } = this.props;
        //     const { data } = comp;
        //     const { imagesList } = data;
        //     console.log('props-parent-get', imagesList);
        //     return imagesList;
        // }
        if (this.props && this.props.competition && this.props.competition.pageData
            && this.props.competition.pageData.items) {
            return this.props.competition.pageData.items;
        }
        else {
            const { competition: comp } = this.props;
            const { data } = comp;
            const { imagesList } = data;
            console.log('props-parent-get', imagesList);
            return imagesList;
        }
    }

    truncateString = (string, length) => {
        if (string.length > length) {
            return string.substring(0, length).trim() + '...';
        }
        else {
            return string;
        }
    }

    getImageUrl = (data) => {
        switch (data.assetTypeId) {
            case 2:
                return "";
            case 3:
                return data.s3_bucket_url + data.thumbnailImageKey;
            default:
                return data.s3_bucket_url + data.s3_key_prefix + data.image_name;
        }
    }

    getAssetLoaderUrl = (data) => {
        return data.s3_bucket_url + data.s3_key_prefix + data.image_name;
    }

    clearAutoCarouselInterval() {
        if (this.state.autoCarouselIntervalObject > 0) {
            clearInterval(this.state.autoCarouselIntervalObject);
            this.setState({
                autoCarouselIntervalObject: 0
            });
        }
    }

    mostRecent = e => {
        // // const { imagesList } = this.props.comp;
        // this.processDefaultFilters(1, this.getParentList());
        // // this.setState({ imagesList });
        this.setState({ filterImageState: 1 });
        this.changeImagesList({ sort: 'recent' }, 'sort');
        this.clearAutoCarouselInterval();
    };

    mostPopular = e => {
        // this.processDefaultFilters(2, this.getParentList());
        this.setState({ filterImageState: 2 });
        this.changeImagesList({ sort: 'popular' }, 'sort');
        this.clearAutoCarouselInterval();
    };

    randomFilter = e => {
        // this.processDefaultFilters(3, this.getParentList());
        this.setState({ filterImageState: 3 });
        this.changeImagesList({ sort: 'random' }, 'sort');
        this.clearAutoCarouselInterval();

        // var query = window.location.hash.substring(1);
        // var self = this;
        // this.setState({ filterImageState: 3 });
        // axios
        //   .get(API_V2_URL + '/competition/hash/' + query)
        //   .then(function(response) {
        //     self.setState({ hashData: response.data });
        //   });
    };

    customFilter = (e, filterId) => {
        e.preventDefault();
        if (filterId) {
            // const { imagesList } = this.props.comp;
            // let filteredImagesList = imagesList.filter(image => image.selectedFilters
            //     && image.selectedFilters.includes(filterId)
            // );
            // // this.trackClickEvent(filterId);
            // this.setState({ filteredImagesList: filteredImagesList });
            this.changeImagesList({ filter: filterId }, 'filter');
            this.setState({ customFilterImageState: filterId });
            this.clearAutoCarouselInterval();
        }
    };

    openModal(e, id) {
        e.preventDefault();
        if (this.props.comp && this.props.comp.imagesList
            && this.props.comp.imagesList.length > 0) {
            let assetUrl = null;
            this.props.comp.imagesList.forEach(image => {
                if (image.id === id) {
                    assetUrl = this.getAssetLoaderUrl(image);
                    this.setState({ assetTypeId: image.assetTypeId });
                    this.setState({ popupImageDescription: image.image_description });
                }
            });
            this.setState({ popupAssetUrl: assetUrl });
            this.setState({ open: true });
        }
    }

    modalCustomStyling(assetTypeId) {
        let styleSet = { width: 'auto', padding: '0px', background: 'transparent', border: '0px' };
        if (assetTypeId === 4) {
            styleSet.width = '90%';
            styleSet.height = '90%';
            return styleSet;
        }
        else if (assetTypeId > 0) {
            return styleSet;
        }
        return {};
    }

    closeModal() {
        this.setState({ open: false });
        this.setState({ assetTypeId: 0 });
        this.setState({ popupAssetUrl: null });
    }

    renderAssetInPopup(assetTypeId) {
        switch (assetTypeId) {
            case 1:
                return <img className="image-viewer" src={this.state.popupAssetUrl} />;
            case 2:
                return <audio className="audio-playback" controls>
                    <source src={this.state.popupAssetUrl} type="audio/mpeg" />
                    Your browser does not support the audio element.
                </audio>;
            case 3:
                return <video className="video-playback" controls>
                    <source src={this.state.popupAssetUrl} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>;
            case 4:
                // this.setState({ open: false });
                // window.open(this.state.popupAssetUrl);
                return <iframe className="pdf-viewer" src={this.state.popupAssetUrl}></iframe>;
                break;
            default:
                return <div>{this.state.popupImageDescription}</div>;
        }
    }

    getImagesList(pageSet) {
        const { competition: comp } = this.props;
        const { data } = comp;
        if (data && data.hash) {

            this.props.dispatch(
                getAcceptedImageList(
                    data.hash,
                    pageSet,
                    this.props.dispatch
                )
            );
        }
    }

    changeImagesList(inputData, type) {

        let limit = 12;
        if ([5850].includes(this.props.comp.id)) {
            limit = 18;
        }
        let pageSet = {
            limit
        };

        let pageSetList = [];

        switch (type) {
            case 'page':
                pageSet.page = inputData.page;
                pageSetList = ['sort', 'filter'];
                break;
            case 'sort':
                pageSet.page = 1;
                pageSet.sort = inputData.sort;
                pageSetList = ['limit', 'filter'];
                break;
            case 'filter':
                pageSet.page = 1;
                pageSet.filter = inputData.filter;
                pageSetList = ['limit', 'sort'];
                break;
            default:
                pageSet.page = 1;
                pageSet = inputData;
                pageSetList = ['page', 'limit', 'sort', 'filter'];
                break;
        }

        pageSetList.forEach((item) => {
            if (this.props.competition.pageData[item] && this.props.competition.pageData[item] != '') {
                pageSet[item] = this.props.competition.pageData[item];
            }
        });

        console.log('page-set-input', pageSet);

        this.getImagesList(pageSet);
    }

    goToPage(page) {

        let pageSet = {
            page
        };

        this.changeImagesList(pageSet, 'page');

    }

    goToNextPage() {
        let changePage = false;
        let page = 2;
        if (this.props && this.props.competition && this.props.competition.pageData
            && this.props.competition.pageData.page) {
            let total = this.props.competition.pageData.total;
            let limit = this.props.competition.pageData.limit;
            let pageCur = this.props.competition.pageData.page;

            if (total && total > (pageCur * limit)) {
                page = pageCur + 1;
                changePage = true;
                // } else {
                //     this.setState({
                //         pageSet: {
                //             ...this.state.pageSet,
                //             isNextEnabled: false
                //         }
                //     });
            }
        }
        console.log('next-page', changePage);
        if (changePage) {
            this.goToPage(page);
        }
        // if (!this.props.competition.nextEnabled) {
        //     return;
        // }
        // this.setState({
        //     page: ++this.state.page
        // });
        // this.goToPage(this.state.page);
    }

    goToPrevPage() {
        let changePage = false;
        let page = 1;
        if (this.props && this.props.competition && this.props.competition.pageData
            && this.props.competition.pageData.page) {
            let total = this.props.competition.pageData.total;
            let limit = this.props.competition.pageData.limit;
            let pageCur = this.props.competition.pageData.page;

            if (pageCur > 1) {
                page = pageCur - 1;
                changePage = true;
                // } else {
                //     this.setState({
                //         pageSet: {
                //             ...this.state.pageSet,
                //             isNextEnabled: false
                //         }
                //     });
            }
        }
        console.log('prev-page', changePage);
        if (changePage) {
            this.goToPage(page);
        }
        // if (!this.props.competition.previousEnabled) {
        //     return;
        // }
        // this.setState({
        //     page: (this.state.page > 0) ? --this.state.page : 0
        // });
        // this.goToPage(this.state.page);
    }


    resizeContainer = () => {
        const { competition: comp } = this.props;
        const { data } = comp;

        let useStyle = false;
        let useStyleBg = '';

        if (data) {
            if (data.bgColor) {
                document.getElementById('root').style.backgroundColor = data.bgColor;
                document.getElementById('root').style.minHeight = '100vh';
            }
            const iw = window.innerWidth;
            if (data.desktopBg && iw >= 1024) {
                // document.body.style.backgroundImage = `url(${data.desktopBg.file})`;
                useStyle = true;
                useStyleBg = data.desktopBg.file;
            } else if (data.tabletBg && iw < 1024 && iw >= 450) {
                // document.body.style.backgroundImage = `url(${data.tabletBg.file})`;
                useStyle = true;
                useStyleBg = data.tabletBg.file;
            } else if (data.mobileBg && iw < 450) {
                // document.body.style.backgroundImage = `url(${data.mobileBg.file})`;
                useStyle = true;
                useStyleBg = data.mobileBg.file;
            }

            // iphone/ipad background fix
            if (useStyle) {
                const styles = `
                    body {
                    background: url(${useStyleBg}) no-repeat center center fixed;
                    }

                    body:after{
                        content:"";
                        position:fixed; /* stretch a fixed position to the whole screen */
                        top:0;
                        height:100vh; /* fix for mobile browser address bar appearing disappearing */
                        left:0;
                        right:0;
                        z-index:-1; /* needed to keep in the background */
                        background: url(${useStyleBg}) center center;
                        -webkit-background-size: cover;
                        -moz-background-size: cover;
                        -o-background-size: cover;
                        background-size: cover;
                    }
                `;

                var styleSheet = document.createElement("style");
                styleSheet.innerText = styles;
                document.head.appendChild(styleSheet);
            }

            document.title = data.name.replace(/(<([^>]+)>)/ig, ' ').trim();
            window.setTimeout(() => {
                let elHeight = document.body.scrollHeight;
                if (window.self !== window.top) {
                    window.parent.postMessage(
                        `benchvoteResize-${elHeight}`
                    );
                }
                // hide loader
                this.setState({ ...this.state, loader: false })
            }, 500);
        }
    }

    updateGrid() {
      console.log('loaded layout');
      if (this.grid) {
        this.grid.updateLayout();
      }
    }

    upVote = (id, vote, index) => {
        if (document.cookie.indexOf('upvote=1') == -1 && this.props
            && this.props.competition && this.props.competition.pageData
            && this.props.competition.pageData.items && this.props.competition.pageData.items.length) {
            // const { imagesList } = this.props.comp;
            const imagesList = this.props.competition.pageData.items;
            imagesList[index].vote_count = vote + 1;
            this.setState({ imagesList });
            var date = new Date();
            var midnight = new Date(
                date.getFullYear(),
                date.getMonth(),
                date.getDate(),
                23,
                59,
                59
            );
            document.cookie = 'upvote=1; expires=' + midnight.toUTCString();

            axios({
                method: 'post',
                url: API_V2_URL + '/image-upload/vote',
                headers: {},
                data: { image_upload_id: id }
            });
        }
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        // console.log('prev-props', prevProps);
        // console.log('state-props', this.state);
        // console.log('prev-state', prevState);
        // console.log('prev-state-props', this.props);
        if ((!prevProps.competition || !prevProps.competition.dataAvailable) && this.props.competition
            && this.props.competition.dataAvailable && !window.codeInjectedForEntryPage) {
            this.resizeContainer();
            // this.render();
            this.goToPage(1);

            console.log('props-1', this.props.competition.data);
            console.log('state-1', this.state.autoCarouselIntervalObject);

            const secondsToChangePage = 15;

            if (this.state.autoCarouselIntervalObject == 0 && this.props && this.props.competition
                && this.props.competition.data && this.props.competition.data.photowallConfigs
                && this.props.competition.data.photowallConfigs.displayAutoCarousel) {
                let autoCarouselIntervalObject = setInterval(() => {
                    if (this.props && this.props.competition && this.props.competition.pageSet
                        && this.props.competition.pageSet.isNextEnabled) {
                        this.goToNextPage();
                    } else {
                        this.goToPage(1);
                    }
                }, secondsToChangePage * 1000);
                console.log('interval-started', autoCarouselIntervalObject);
                this.setState({
                    autoCarouselIntervalObject
                });
            }

            // CSS FILES
            var fileref = document.createElement("link")
            fileref.setAttribute("rel", "stylesheet")
            fileref.setAttribute("type", "text/css")
            fileref.setAttribute("href", this.props.competition.data.cssContentUrl)
            if (typeof fileref != "undefined") {
                document.getElementsByTagName("head")[0].appendChild(fileref);
            }

            // FONT CSS FILES
            var fileref = document.createElement("link")
            fileref.setAttribute("rel", "stylesheet")
            fileref.setAttribute("type", "text/css")
            fileref.setAttribute("href", this.props.competition.data.fontUrl)
            if (typeof fileref != "undefined") {
                document.getElementsByTagName("head")[0].appendChild(fileref);
            }

        }
        if (this.props.competition && prevProps.competition
            && prevProps.competition.loader != this.props.competition.loader) {
            this.setState({
                loader: this.props.competition.loader
            });
        }
    }

    componentDidMount() {

        // let hash = this.props.location.hash;
        // hash = hash ? hash.replace(/(^#)/g, "") : '';

        let hash = getUrlWord(this.props.match.url, this.props.location.hash);

        if (hash) {
            console.log('hash-new', hash);
            this.props.dispatch(getAllRounds(
                hash,
                this.props.dispatch
            ));
            this.setState({ hash });
            this.setState({ ...this.state, loader: true });
            this.interval = setInterval(() => this.updateGrid(), 1500);

            var up = false;
            var lastPosition;
            this.intervalScroll = setInterval(function () {
              var $container = $(".card");
              if ($container) {
                var position = $container.scrollTop();
                // var height = $container.scrollHeight;
                // console.log('height', height);

                // If we haven't moved, switch direction
                if (position === lastPosition) up = !up;
                lastPosition = position;

                if (up) {
                  // Going up
                  // $container.scrollTop(position - 100);
                  $container.animate({ scrollTop: position - 100 }, 4200);
                } else {
                  // Going down
                  // $container.scrollTop(position + 100);
                  $container.animate({ scrollTop: position + 100 }, 4200);
                }
              }
            }, 100);

        }

    }

    getUrlExtension = (url) => {
      return url.split(/[#?]/)[0].split('.').pop().trim();
    }

    getVideoExtensions = (url) => {
      return ['mp4', 'avi', 'webm', 'mov']
    }

    isVideo = (url) => {
      var urlExt = this.getUrlExtension(url);
      return (this.getVideoExtensions().includes(urlExt));
    }

    componentWillUnmount() {
      clearInterval(this.interval);
      clearInterval(this.intervalScroll);
    }

    render() {

        const { competition, t } = this.props;
        const { data, enabledSocialNetworks } = competition;

        console.log('props-parent', this.props);
        console.log('props-parent-1', data);

        if (!data) {
            return (<div></div>);
        }

        let hideFullContent = false;
        if (data && data.photowallConfigs && data.photowallConfigs.hideFullContent) {
            hideFullContent = true;
        }

        const hideFullContentCss = hideFullContent ? 'show-full-content' : '';
        const hideFullContentCssMb0 = hideFullContent ? 'm-b-0' : '';

        this.defaultShape = data && data.defaultShape;
        if (this.defaultShape && this.shapesList[this.defaultShape]) {
          this.classRadius = this.shapesList[this.defaultShape];
        }

        return (
            <React.Fragment>

                {data && data.desktopBg && data.desktopBg.file
                  && this.isVideo(data.desktopBg.file)
                ? <video autoPlay={true} muted={true} loop={true} playsInline={true} id="myVideo">
                      <source src={data.desktopBg.file} type="video/mp4"/>
                </video> : null}

                <svg height="0" width="0">
                  <defs>
                    <clipPath id="infoBottomClip" clipPathUnits="objectBoundingBox">
                        <polygon points="1.02 -0.01, 0.5 1, -0.02 -0.01"/>
                    </clipPath>
                  </defs>
                </svg>
                <svg height="0" width="0">
                  <defs>
                    <clipPath id="infoBottomBorderClip" clipPathUnits="objectBoundingBox">
                        <polygon points="0 0.72, 0.5 0.98, 1 0.72, 1 0.75, 0.5 1, 0 0.75"/>
                    </clipPath>
                  </defs>
                </svg>

                {this.state.loader ?
                    <div className={"loaderCss"}>
                        <style dangerouslySetInnerHTML={{
                            __html: `
                    body { overflow: hidden; }
                    `}} />
                        <div className={"loader"} ><FadeLoader size={150} color={"#ffffff"} loading={this.state.loader} /></div>
                    </div> : null}

                <div className={this.classRadius + ' content'}>
                    <div className='panels-cont'>

                        {!data.photowallConfigs || !data.photowallConfigs.displayHideLogo ?
                            <div className='logo-form-group'>
                                <div className='logos-cont'>
                                    {data.logoBg ? <img src={data.logoBg.file} className='pl-logo logo-image img-fluid center-block' /> : null}
                                </div>
                            </div>
                            : null}

                        <div className='left-panel'>
                            {!data.photowallConfigs || !data.photowallConfigs.displayHideFilters ?

                                <div>
                                    {/* here */}
                                    {/* <Photos showLoader={(e) => this.showLoader(this, e)} /> */}
                                    {/* photowall filters */}
                                    {(data.photowallConfigs && data.photowallConfigs.enableFilter && data.photowallFilters.length > 0) ? (
                                        <div className='categoryFilter filterImage'>
                                            {data.photowallFilters.map((filter) =>
                                                <a onClick={(e) => this.customFilter(e, filter.id)}
                                                    style={this.state.customFilterImageState !== filter.id ? { borderColor: data.borderColor, backgroundColor: data.backgroundColor, color: data.primaryColor } : { borderColor: data.borderColor, color: '#ffffff' }}
                                                    className={(this.state.customFilterImageState === filter.id ? 'filterImageSelected ' : '')}>
                                                    {filter.filterName}
                                                </a>
                                            )}
                                        </div>
                                    ) : null}

                                    {/* photowall sort */}
                                    <div className='defaultFilter defaultFilterImage filterImage'>
                                        <a onClick={this.mostRecent}
                                            style={(this.state.filterImageState !== 1) ? { borderColor: data.borderColor, backgroundColor: data.backgroundColor, color: data.primaryColor } : { borderColor: data.borderColor, color: '#ffffff' }}
                                            className={(this.state.filterImageState === 1 ? 'filterImageSelected filterMostRecent ' : 'filterMostRecent')}>Recent</a>
                                        <a onClick={this.mostPopular} style={(this.state.filterImageState !== 2) ? { borderColor: data.borderColor, backgroundColor: data.backgroundColor, color: data.primaryColor } : { borderColor: data.borderColor, color: '#ffffff' }} className={(this.state.filterImageState === 2 ? 'filterImageSelected filterMostPopular ' : 'filterMostPopular')}>Popular</a>
                                        <a onClick={this.randomFilter} style={(this.state.filterImageState !== 3) ? { borderColor: data.borderColor, backgroundColor: data.backgroundColor, color: data.primaryColor } : { borderColor: data.borderColor, color: '#ffffff' }} className={(this.state.filterImageState === 3 ? 'filterImageSelected filterRandom ' : 'filterRandom')}>Random</a>
                                    </div>
                                </div> : null}

                            <div className='photoGrid displayGrid'>
                                {(this.props && this.props.competition && !this.props.competition.loader) ?
                                    (<StackGrid
                                        columnWidth={280}
                                        gutterWidth={20}
                                        gutterHeight={10}
                                        gridRef={grid => this.grid = grid}
                                    >
                                        {this.getParentList().map((data, index) => {
                                            return (
                                                <div key={index}>
                                                    <div className='card' style={{ borderColor: competition.data.borderColor, backgroundColor: competition.data.backgroundColor, color: competition.data.primaryColor }}>
                                                      <div>
                                                        {data.assetTypeId && (data.assetTypeId === 2) ?
                                                            <LazyLoad onContentVisible={this.updateGrid}>
                                                                <div onClick={(e) => this.openModal(e, data.id)}
                                                                    style={{
                                                                        backgroundSize: `cover`,
                                                                        backgroundPosition: `center`,
                                                                        height: `162px`
                                                                    }}
                                                                    className={'head play-content-outer'}
                                                                >
                                                                    <div className='play-content-inner'><i className='fa fa-music fa-5x' /></div>
                                                                </div>
                                                            </LazyLoad> : ''}
                                                        {data.assetTypeId && (data.assetTypeId === 1 || data.assetTypeId === 3) ?
                                                            <LazyLoad onContentVisible={this.updateGrid}>
                                                                <div onClick={(e) => this.openModal(e, data.id)}
                                                                    style={{
                                                                        backgroundImage: `url(${this.getImageUrl(data)})`,
                                                                        backgroundSize: `cover`,
                                                                        backgroundRepeat: `no-repeat`,
                                                                        backgroundPosition: `center center`,
                                                                        minHeight: `162px`,
                                                                        borderTopLeftRadius: '8px',
                                                                        borderTopRightRadius: '8px'
                                                                    }}
                                                                    className={`${data.assetTypeId === 3 ? 'head play-content-outer' : 'head'}`}
                                                                >
                                                                    <img src={this.getImageUrl(data)} style={{
                                                                        visibility: `hidden`,
                                                                        height: `auto`,
                                                                        width: '100%'
                                                                    }}/>
                                                                    {data.assetTypeId === 3 ?
                                                                        <div className='play-content-inner'><i className='fa fa-play fa-5x' /></div>
                                                                        : ''}
                                                                </div>
                                                                {/* <img
                              className='card-img-top'
                              src={
                                data.s3_bucket_url +
                                data.s3_key_prefix +
                                data.image_name
                              }
                              alt='Card image cap'
                            /> */}
                                                            </LazyLoad> : ''}
                                                        {data.assetTypeId && (data.assetTypeId === 4) ?
                                                            <LazyLoad onContentVisible={this.updateGrid}>
                                                                <div onClick={(e) => this.openModal(e, data.id)}
                                                                    style={{
                                                                        backgroundSize: `cover`,
                                                                        backgroundPosition: `center`,
                                                                        height: `162px`
                                                                    }}
                                                                    className={'head play-content-outer'}
                                                                >
                                                                    <div className='play-content-inner'><i className='fa fa-file-pdf-o fa-5x' /></div>
                                                                </div>
                                                            </LazyLoad> : ''}
                                                        {data.assetTypeId ?
                                                            <div className='card-body'>
                                                                {competition.data.id != 5484 ?
                                                                    <h5 className={`card-title ${hideFullContentCssMb0}`}>
                                                                        {data.first_name + ' ' + data.last_name}
                                                                    </h5> :
                                                                    <h5 className={`card-title ${hideFullContentCssMb0}`}>
                                                                        {data.first_name}
                                                                    </h5>}
                                                                {!hideFullContent ?
                                                                <div>
                                                                <p onClick={(e) => this.openModal(e, data.id)}
                                                                    className='card-text'
                                                                >{data.image_description}</p>
                                                                <div className='clearfix'>
                                                                    <i
                                                                        className='fa fa-thumbs-up fa-1x votes'
                                                                        onClick={() =>
                                                                            this.upVote(data.id, data.vote_count, index)
                                                                        }
                                                                    />
                                                                    <span className='upvote'>{data.vote_count}</span>
                                                                </div></div> : ''}
                                                            </div> : ''}
                                                        {!data.assetTypeId ?
                                                            <div className='card-body'>
                                                                <p onClick={(e) => this.openModal(e, data.id)}
                                                                    className='onlyAssetPopupDesc card-text onlyTextContent'
                                                                >{this.truncateString(data.image_description, 175)}</p>
                                                                {competition.data.id != 5484 ?
                                                                    <h5 className={`card-title ${hideFullContentCssMb0}`}>
                                                                        {data.first_name + ' ' + data.last_name}
                                                                    </h5> :
                                                                    <h5 className={`card-title ${hideFullContentCssMb0}`}>
                                                                        {data.first_name}
                                                                    </h5>}
                                                                {!hideFullContent ?
                                                                <div>
                                                                <div className='clearfix'>
                                                                    <i
                                                                        className='fa fa-thumbs-up fa-1x votes'
                                                                        onClick={() =>
                                                                            this.upVote(data.id, data.vote_count, index)
                                                                        }
                                                                    />
                                                                    <span className='upvote'>{data.vote_count}</span>
                                                                </div></div> : ''}
                                                            </div> : ''}
                                                    </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </StackGrid>) : null}

                                {/* </div> */}

                                {/* <div className='load-more'> */}


                            </div>

                            <Popup
                                open={this.state.open}
                                closeOnDocumentClick
                                onClose={this.closeModal}
                                contentStyle={(this.modalCustomStyling(this.state.assetTypeId))}
                                overlayStyle={{ background: "rgba(0, 0, 0, 0.8)" }}
                                className={(this.state.assetTypeId > 0 ? 'assetPopup' : '')}
                            >
                                <div className="inner">
                                    <a className="close" onClick={this.closeModal}>
                                        <i class="fa fa-times" aria-hidden="true"></i>
                                    </a>
                                    {this.renderAssetInPopup(this.state.assetTypeId)}
                                </div>
                            </Popup>

                            <div className='optin-row text-center'>

                                {this.props.competition.pageSet.isPrevEnabled || this.props.competition.pageSet.isNextEnabled
                                    ? (<div className='pagination' style={{ color: competition.data.primaryColor }}>
                                        <i className={`fa fa-chevron-left previous fa-lg ${this.props.competition.pageSet.isPrevEnabled ? '' : 'disabled'}`}
                                            onClick={this.goToPrevPage} aria-hidden="true" title='Previous page'></i>
                                        <i className={`fa fa-chevron-right next fa-lg ${this.props.competition.pageSet.isNextEnabled ? '' : 'disabled'}`}
                                            onClick={this.goToNextPage} aria-hidden="true" title='Next page'></i>
                                    </div>)
                                    : null}

                            </div>

                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

//-------------------------------------------------------------------------
//-------------------- Mapping store to App's props ----------------------
//-------------------------------------------------------------------------

const mapStateToProps = (state, ownProps) => {

    const prj = state.default;
    return {
        ...ownProps,
        competition: prj.competition,
        comp: prj.competition.data,
        locale: prj.locale
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Display));
